const KHUSHI_CONFIG_ID = 'khushi-extension-config';
const KHUSHI_HEADER_SELECTOR = '[data-khushi-wishlist-open]';
const KHUSHI_PRODUCT_ACTION = 'khushi-wishlist-product-action';
const KHUSHI_DOM_CHANGED_EVENT = 'khushi:dom:changed';
const KHUSHI_DYNAMIC_HOST_SELECTOR = 'header-actions, product-form-component, product-card[data-product-id]';

let khushiMountQueued = false;

function readKhushiConfig() {
  const node = document.getElementById(KHUSHI_CONFIG_ID);
  if (!node) return {};

  try {
    return JSON.parse(node.textContent || '{}');
  } catch (error) {
    console.warn('[Khushi Extension] Invalid runtime configuration', error);
    return {};
  }
}

function createHeaderWishlistButton() {
  const config = readKhushiConfig();
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'header-actions__action button-unstyled khushi-wishlist-header-button';
  button.setAttribute('data-khushi-wishlist-open', '');
  button.setAttribute('data-khushi-customer-id', String(config.customerId || ''));
  button.setAttribute('aria-label', 'Wishlist');
  button.setAttribute('aria-haspopup', 'dialog');
  button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-controls', 'khushi-wishlist-drawer');
  button.innerHTML = `
    <span class="header-actions__cart-icon khushi-wishlist-header-icon" data-khushi-wishlist-icon>
      <span class="svg-wrapper" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <div class="cart-bubble visually-hidden" data-khushi-wishlist-bubble data-maintain-ratio>
        <span class="cart-bubble__background"></span>
        <span class="cart-bubble__text">
          <span class="cart-bubble__text-count hidden" data-khushi-wishlist-count aria-hidden="true">0</span>
        </span>
      </div>
    </span>`;

  const bubble = button.querySelector('[data-khushi-wishlist-bubble]');
  if (bubble) {
    if (config.bubbleBackground) bubble.style.setProperty('--cart-bubble-background-fallback', String(config.bubbleBackground));
    if (config.bubbleText) bubble.style.setProperty('--cart-bubble-text-fallback', String(config.bubbleText));
  }

  return button;
}

function mountHeaderWishlist(root = document) {
  const containers = [];
  if (root instanceof Element && root.matches('header-actions')) containers.push(root);
  root.querySelectorAll?.('header-actions').forEach((node) => containers.push(node));

  for (const container of containers) {
    if (container.querySelector(KHUSHI_HEADER_SELECTOR)) continue;
    const button = createHeaderWishlistButton();
    const cartAction = container.querySelector('[data-testid="cart-drawer-trigger"]') || container.querySelector('a.action__cart');
    const liveRegion = container.querySelector('[data-testid="cart-count-live-region"]');
    container.insertBefore(button, cartAction || liveRegion || null);
  }
}

function createProductWishlistAction(productForm) {
  const productId = String(productForm.dataset.productId || '');
  const productUrl = String(productForm.dataset.productUrl || location.pathname);
  if (!productId) return null;

  const action = document.createElement(KHUSHI_PRODUCT_ACTION);
  action.className = 'khushi-wishlist-product-action';
  action.dataset.productId = productId;
  action.dataset.productUrl = productUrl;
  action.innerHTML = `
    <button
      type="button"
      class="button-secondary khushi-wishlist-product-button khushi-wishlist-product-action__button"
      data-khushi-wishlist-product-action-button
      data-product-id="${productId}"
      aria-label="Add to wishlist"
      aria-pressed="false"
    >
      <span class="svg-wrapper" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="khushi-wishlist-product-action__label">Add to Wishlist</span>
    </button>`;

  const button = action.querySelector('[data-khushi-wishlist-product-action-button]');
  if (button) button.dataset.productUrl = productUrl;
  return action;
}

function mountProductWishlist(root = document) {
  const main = document.querySelector('#MainContent[data-template^="product"]');
  if (!main) return;

  const forms = [];
  if (root instanceof Element && root.matches('product-form-component')) forms.push(root);
  root.querySelectorAll?.('product-form-component').forEach((node) => forms.push(node));

  for (const productForm of forms) {
    if (!main.contains(productForm)) continue;
    const buttons = productForm.querySelector('.product-form-buttons');
    if (!buttons || buttons.querySelector(`:scope > ${KHUSHI_PRODUCT_ACTION}`)) continue;

    const action = createProductWishlistAction(productForm);
    if (!action) continue;

    const quantity = buttons.querySelector(':scope > .quantity-selector-wrapper');
    const addToCart = Array.from(buttons.children).find((child) => child.querySelector?.('add-to-cart-component'));
    if (quantity) quantity.insertAdjacentElement('afterend', action);
    else if (addToCart) buttons.insertBefore(action, addToCart);
    else buttons.appendChild(action);
  }
}

function auditKhushiExtension() {
  if (!window.Shopify?.designMode) return;

  const missing = [];
  if (!document.getElementById(KHUSHI_CONFIG_ID)) missing.push('runtime config');
  if (!document.querySelector('[data-khushi-drawer-editor-config="cart"]')) missing.push('Cart drawer editor');
  if (!document.querySelector('[data-khushi-drawer-editor-config="wishlist"]')) missing.push('Wishlist drawer editor');
  if (!document.querySelector(KHUSHI_HEADER_SELECTOR)) missing.push('header Wishlist action');

  const main = document.querySelector('#MainContent[data-template^="product"]');
  if (main && !main.querySelector(KHUSHI_PRODUCT_ACTION)) missing.push('product Wishlist action');

  document.documentElement.dataset.khushiExtensionStatus = missing.length ? 'warning' : 'ok';
  if (missing.length) console.warn(`[Khushi Upgrade Guard] Missing integration: ${missing.join(', ')}`);
  else console.info('[Khushi Upgrade Guard] Extension contract OK');
}

function mountKhushiExtension(root = document) {
  mountHeaderWishlist(root);
  mountProductWishlist(root);
}

function notifyKhushiDomChanged(root) {
  window.dispatchEvent(new CustomEvent(KHUSHI_DOM_CHANGED_EVENT, { detail: { root } }));
}

function scheduleKhushiMount() {
  if (khushiMountQueued) return;
  khushiMountQueued = true;

  requestAnimationFrame(() => {
    khushiMountQueued = false;
    mountKhushiExtension(document);
    notifyKhushiDomChanged(document);
    window.setTimeout(auditKhushiExtension, 100);
  });
}

mountKhushiExtension(document);
window.setTimeout(auditKhushiExtension, 250);

document.addEventListener('shopify:section:load', scheduleKhushiMount);
window.addEventListener('pageshow', scheduleKhushiMount);

// One shared dynamic-host observer for Khushi mounting. It scans the document
// only when Horizon actually inserts a relevant host, so batched DOM changes
// cannot cause one new card/form/header to be missed.
const khushiObserver = new MutationObserver((entries) => {
  for (const entry of entries) {
    for (const node of entry.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches(KHUSHI_DYNAMIC_HOST_SELECTOR) || node.querySelector?.(KHUSHI_DYNAMIC_HOST_SELECTOR)) {
        scheduleKhushiMount();
        return;
      }
    }
  }
});

khushiObserver.observe(document.documentElement, { childList: true, subtree: true });
